import type { UseRpcOptions } from '@scayle/storefront-nuxt/composables'

export default ({
  key = 'useCountryRedirect',
  params,
  options,
}: {
  key?: string
  params?: any
  options?: UseRpcOptions<'resolveIpToCountry'>
}) => {
  const currentShop = useCurrentShop()
  const availableShops = useAvailableShops()

  const {
    refresh,
    data: userCountry,
    status,
  } = useRpc('resolveIpToCountry', key, params, options)

  const userShop = computed(() => {
    return availableShops.value.find((i) => i.country === userCountry.value)
  })

  const userCountryShopAvailable = computed(
    () =>
      userCountry.value !== false &&
      userCountry.value !== currentShop.value.country &&
      userShop.value !== undefined,
  )

  return {
    refresh,
    status,
    userCountry,
    userShop,
    userCountryShopAvailable,
  }
}
